var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgList = function SvgList(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.124023 3.41457V24.2146C0.124023 24.4355 0.303121 24.6146 0.524067 24.6146H15.7241C15.9449 24.6146 16.124 24.4355 16.124 24.2146V7.41468C16.124 7.40579 16.1197 7.39821 16.1189 7.38947C16.1169 7.35438 16.11 7.31978 16.0984 7.28666C16.094 7.27381 16.0909 7.26145 16.0852 7.24893C16.0658 7.20543 16.0388 7.16573 16.0052 7.13179L12.0052 3.13184C11.9713 3.09806 11.9314 3.07104 11.8876 3.05177C11.8756 3.04666 11.8634 3.04237 11.8508 3.03858C11.8174 3.02705 11.7826 3.02013 11.7472 3.01782C11.7405 3.01898 11.7325 3.01469 11.7241 3.01469H0.524067C0.303121 3.01469 0.124023 3.19363 0.124023 3.41457ZM14.7584 7.01464H12.124V4.38025L14.7584 7.01464ZM0.923946 3.81462H11.3241V7.41468C11.3241 7.63547 11.5032 7.81456 11.724 7.81456H15.324V23.8147H0.923946V3.81462Z",
    fill: "#00204B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.924 21.4146V22.2145H18.124C18.3449 22.2145 18.524 22.0356 18.524 21.8146V1.01464C18.524 0.793691 18.3449 0.614594 18.124 0.614594H2.92397C2.70302 0.614594 2.52393 0.793691 2.52393 1.01464V2.2146H3.32401V1.41452H17.7239V21.4146H16.924Z",
    fill: "#00204B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.32397 8.61465H12.9239V9.41457H3.32397V8.61465Z",
    fill: "#00204B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.32397 6.21455H6.524V7.01463H3.32397V6.21455Z",
    fill: "#00204B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.32397 11.0146H9.72402V11.8147H3.32397V11.0146Z",
    fill: "#00204B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5239 11.0146H12.9239V11.8147H10.5239V11.0146Z",
    fill: "#00204B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.32397 13.4145H12.9239V14.2146H3.32397V13.4145Z",
    fill: "#00204B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.32397 18.2146H12.9239V19.0146H3.32397V18.2146Z",
    fill: "#00204B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92383 15.8146H12.9238V16.6145H6.92383V15.8146Z",
    fill: "#00204B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.32397 15.8146H6.12395V16.6145H3.32397V15.8146Z",
    fill: "#00204B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.32397 20.6146H4.92399V21.4146H3.32397V20.6146Z",
    fill: "#00204B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72388 20.6146H12.9238V21.4146H5.72388V20.6146Z",
    fill: "#00204B"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/list.af6061ec.svg";
export { ForwardRef as ReactComponent };